import axios from "axios";
import { webApiArchivosCapacitacion, webApiIntroduccionCapacitacion } from "../routes/endpoints";

export const getIntroduccionData = async () => {
    const res = await axios.get(webApiIntroduccionCapacitacion);
    const { data } = res;
    return data;
  };

  export const getArchivosData = async () => {
    const res = await axios.get(webApiArchivosCapacitacion);
    const { data } = res;
    return data;
  };